import { xhr } from '@/api/config/Repository'
import PenaltyUploadRepository from '../PenaltyUploadRepository'
import PenaltyUploadRequestDTO from '../dto/PenaltyUploadRequestDTO'
export default class PenaltyUploadRepositoryImpl implements PenaltyUploadRepository {
  async penaltyUploadData (request): Promise<any> {
    const endpoint = 'lp/createLPImport'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<PenaltyUploadRequestDTO, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: PenaltyUploadRepositoryImpl.ts:10 ~ PenaltyUploadRepositoryImpl ~ PenaltyUploadData ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }
}
